'use client';
import UIButton from '@/components/atoms/UIButtons/UIButton';
import Modal from '@/components/atoms/Modal';

export default function LogoutModal({ isOpen, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div>
        <h2 className="font-semibold text-[#323232] text-xl md:text-2xl xl:text-[26px] leading-[1em] mb-3 max-w-[calc(100%-50px)]">
          Are you sure you want to logout?
        </h2>
        <div className="flex items-center justify-end gap-3 mt-10">
          <UIButton
            variant="primaryTheme"
            rounded="full"
            className="min-w-[140px] sm:w-auto w-1/2"
            onClick={onConfirm}
          >
            Logout
          </UIButton>
          <UIButton
            variant="secondaryTheme"
            rounded="full"
            className="min-w-[140px] sm:w-auto w-1/2"
            onClick={onCancel}
          >
            Cancel
          </UIButton>
        </div>
      </div>
    </Modal>
  );
}
